let addressComplete = null;
const listeners = new Set();

export function getAddressGateComplete() {
  return addressComplete;
}

export function setAddressGateComplete(value) {
  addressComplete = value === null ? null : Boolean(value);
  listeners.forEach((listener) => listener(addressComplete));
}

export function subscribeAddressGate(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function resetAddressGate() {
  setAddressGateComplete(null);
}
